module.exports = __webpack_public_path__ + "img/delete-grey.cc588016.svg";